import { line as lineShape, curveStep, curveMonotoneX } from 'd3-shape';
export var calculatePath = function (curve, xScale, yScale, labelSelector, keyName) {
    var lineShapeType;
    switch (curve) {
        case 'spline':
            lineShapeType = lineShape().curve(curveMonotoneX);
            break;
        case 'step':
            lineShapeType = lineShape().curve(curveStep);
            break;
        default:
            lineShapeType = lineShape();
            break;
    }
    return lineShapeType
        .x(function (d) {
        return xScale(d[labelSelector]);
    })
        .y(function (d) {
        return yScale(d[keyName]);
    });
};
